import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import {RailsPartial, RailsPartialHTML} from '@github-ui/rails-partial'
import {ReposOverview} from '@github-ui/repos-overview/ReposOverview'
import {SplitPageLayout} from '@primer/react'

import {useUpdateRefInfoAndPath} from '../hooks/use-update-ref-info-and-path'
import {codeViewRepoRoute} from '../routes/code-view-repo-route'

export function ReposOverviewPage({payload, isTree}: {payload: DataRouterFileOverviewPayload; isTree: boolean}) {
  useUpdateRefInfoAndPath(payload.refInfo, payload.path)
  return (
    <SplitPageLayout className="container-xl">
      <SplitPageLayout.Header padding="none" divider="none" className="tmp-px-3 tmp-px-lg-5">
        {isTree ? (
          <RailsPartialHTML html={payload.overview.partials.header} partialName="codeViewTreeRoute.Header" />
        ) : (
          <RailsPartial route={codeViewRepoRoute} partialName="Header" />
        )}
      </SplitPageLayout.Header>
      <SplitPageLayout.Content as="div" padding="condensed">
        <ReposOverview payload={payload} className="tmp-pl-lg-3 mt-0" tree={payload.tree} />
      </SplitPageLayout.Content>
      <SplitPageLayout.Pane position="end" sticky={false} divider="none" width="large" className="pr-2">
        {isTree ? (
          <RailsPartialHTML html={payload.overview.partials.sidebar} partialName="codeViewTreeRoute.Sidebar" />
        ) : (
          <RailsPartial route={codeViewRepoRoute} partialName="Sidebar" />
        )}
      </SplitPageLayout.Pane>
    </SplitPageLayout>
  )
}
